function handleCustomBadges(context = document) {
  const cardBadges = context.querySelectorAll(".card__badge");

  cardBadges.forEach(card => {
    const customBadges = card.querySelectorAll("span.badge--custom");
    const bottomLeft = card.querySelector("span.badge--bottom-left");

    if (customBadges.length === 1 && !bottomLeft) {
      card.style.flexDirection = "row";
    }
  });
}

//Esegui subito alla prima apertura della pagina
document.addEventListener("DOMContentLoaded", () => {
  handleCustomBadges();
});

//Osserva nuove card aggiunte con il pulsante "Carica di più"
new MutationObserver(mutations => {
  mutations.forEach(mutation => {
    mutation.addedNodes.forEach(node => {
      if (node.nodeType === 1 && node.classList.contains("collection-product-card")) {
        handleCustomBadges(node);
      }
    });
  });
}).observe(document.body, { childList: true, subtree: true });
